import api from "./api";
import TokenService from "./token.service";
import {clearAccountCache} from "@/services/account.service";

export const login = async (email: string, password: string) => {
    try {
        const {data} = await api
            .post("/login", {
                email: email.trim().toLocaleLowerCase(),
                password
            })
        const {
            access_token: accessToken,
            expires_in: expiresIn,
            refresh_token: refreshToken,
            refresh_token_expires_in: refreshTokenExpiresIn
        } = data;

        TokenService.updateLocalAccessToken(accessToken, expiresIn);
        TokenService.updateLocalRefreshToken(refreshToken, refreshTokenExpiresIn);

        return true;
    } catch (e) {
        return false;
    }

}

export const checkAuth = () => {
    try {
        // Пускаем в кабинет, если есть ЛЮБОЙ живой токен. Access живёт 24ч, а
        // refresh — 30 дней; раньше гейт смотрел ТОЛЬКО access → через сутки его
        // cookie истекала и вход требовался заново каждый день, хотя refresh был
        // ещё жив. Теперь при живом refresh пускаем, а перехватчик (setupInterceptors)
        // на первом 401 молча обновит access → вход держится все 30 дней.
        return (
            !!TokenService.getLocalAccessToken() ||
            !!TokenService.getLocalRefreshToken()
        );
    } catch (e) {
        return false;
    }
};

export const logout = () => {
    TokenService.removeTokens();
    clearAccountCache();
}
